export default "__VITE_ASSET__4b768134__"